import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import { userClient } from '@/js/helpers/backend-clients';

Vue.use(Router);

const scrollBehavior = (to, from, savedPosition) => {
  document.querySelector('header').scrollIntoView();
};

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      component: () =>
        import(/* webpackChunkName: "CardHolderPage" */ '@/pages/CardHolderPage.vue'),
      children: [
        {
          path: '',
          name: 'Login',
          component: () =>
            import(
              /* webpackChunkName: "Login"*/ '@/components/authentifizierung/LoginComponent.vue'
            ),
        },
      ],
    },
    {
      path: '/passwort-vergessen',
      component: () => import(/* webpackChunkName: "CardHolder" */ '@/pages/CardHolderPage.vue'),
      children: [
        {
          path: '',
          name: 'PasswortVergessen',
          component: () =>
            import(
              /* webpackChunkName: "ForgotPassword"*/ '@/components/passwortvergessen/PasswortVergessenComponent.vue'
            ),
        },
      ],
    },
    {
      path: '/passwort-zuruecksetzen',
      component: () => import(/* webpackChunkName: "CardHolder" */ '@/pages/CardHolderPage.vue'),
      children: [
        {
          path: '',
          name: 'PasswortZuruecksetzen',
          component: () =>
            import(
              /* webpackChunkName: "ResetPassword"*/ '@/components/passwortvergessen/PasswortZuruecksetzenComponent.vue'
            ),
        },
      ],
    },
    {
      path: '/passwort-aendern',
      component: () => import(/* webpackChunkName: "CardHolder" */ '@/pages/CardHolderPage.vue'),
      props: {
        title: 'Passwort ändern',
        homeButton: true,
      },
      children: [
        {
          path: '',
          name: 'PasswortAendern',
          component: () =>
            import(
              /* webpackChunkName: "ChangePassword"*/ '@/components/portalkonto/PasswortAendernComponent.vue'
            ),
        },
      ],
    },
    {
      path: '/registrieren',
      component: () => import(/* webpackChunkName: "CardHolder" */ '@/pages/CardHolderPage.vue'),
      children: [
        {
          path: '',
          name: 'Registrierung',
          component: () =>
            import(
              /* webpackChunkName: "Subscribe" */ '@/components/authentifizierung/RegisterSimpleUserComponent.vue'
            ),
        },
      ],
    },
    {
      path: '/nutzungsdauergutachten/map',
      name: 'Nutzungsdauergutachten Map',
      component: () => import(/* webpackChunkName: "AdresseingabePage" */ '@/pages/product/nutzungsdauergutachten/NutzungsdauerAddressInputPage.vue'),
    },
    {
      path: '/kaufpreisaufteilung/map',
      name: 'Kaufpreisaufteilung Map',
      component: () => import(/* webpackChunkName: "AdresseingabePage" */ '@/pages/product/kaufpreisaufteilung/KaufpreisaufteilungAddressInputPage.vue'),
    },
    {
      path: '/gutachtenauswahl',
      name: 'Gutachtenauswahl',
      component: () => import(/* webpackChunkName: "ProductPage" */ '@/pages/GutachtenAuswahlPage.vue'),
    },
    {
      path: '/meine-gutachten',
      name: 'Gutachten',
      component: () =>
        import(/* webpackChunkName: "UnterlagenListePage" */ '@/pages/UnterlagenListePage.vue'),
    },
    {
      path: '/meine-auftraege',
      name: 'Auftraege',
      component: () => import(/* webpackChunkName: "SavedNdgPage" */ '@/pages/SavedNdgPage.vue'),
    },
    {
      path: '/konfiguration/ndg',
      name: 'konfiguration',
      //component: () => import(/* webpackChunkName: "ProduktKonfiguration" */ '@/pages/ConfigurationFramePage.vue')
      component: () =>
        import(/* webpackChunkName: "ProduktKonfiguration" */ '@/pages/NdgConfigurationPage.vue'),
    },
    {
      path: '/konfiguration/kpa',
      name: 'konfigurationKpa',
      component: () =>
        import(/* webpackChunkName: "KpaProduktKonfiguration" */ '@/pages/KpaConfigurationPage.vue'),
    },
    {
      path: '/warenkorb',
      name: 'warenkorb',
      component: () => import(/* webpackChunkName: "Warenkorb" */ '@/pages/KassePage.vue'),
    },
    {
      path: '/produktauswahl',
      name: 'produktauswahl',
      component: () =>
        import(/* webpackChunkName: "Produktauswahl" */ '@/pages/ProduktauswahlPage.vue'),
    },
    {
      path: '/produkt/ndg',
      name: 'produkt',
      component: () =>
        import(/* webpackChunkName: "Produkt" */ '@/pages/NdgProduktPage.vue'),
    },
    {
      path: '/produkt/kpa',
      name: 'produktKpa',
      component: () =>
        import(/* webpackChunkName: "KpaProdukt" */ '@/pages/KpaProduktPage.vue'),
    },
    {
      path: '/email-verifizierung/:token',
      component: () =>
        import(/* webpackChunkName: "CardHolderPage" */ '@/pages/CardHolderPage.vue'),
      children: [
        {
          path: '',
          name: 'Verifizierung',
          component: () =>
            import(
              /* webpackChunkName: "Verifizierung"*/ '@/components/portalkonto/VerifizierungComponent.vue'
            ),
        },
      ],
    },
  ],
  scrollBehavior,
});

/**
 * Anpassung des router.push(), damit die NavigationDuplicated Fehler nicht immer geloggt werden
 */
const originalPush = router.push;
router.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch(err => {
    if (Router.isNavigationFailure(err)) {
      return err;
    }

    return Promise.reject(err);
  });
};


// Listen for browser back/forward button
let isBackNavigation = false;
window.addEventListener('popstate', () => {
  isBackNavigation = true;
});

router.beforeEach(async (to, from, next) => {
  if (isBackNavigation && to.path === '/warenkorb' && !from.path.includes('konfiguration')) {
    await store.dispatch('kasse/reset');
    await store.dispatch('gutachten/reset');
    await store.dispatch('objektbesichtigung/reset');
    await store.dispatch('kaufpreisaufteilung/reset');
    isBackNavigation = false;
    next({ name: 'Gutachtenauswahl' }); // Redirect to Gutachtenauswahl if back button was used
    return;
  }
  await store.dispatch('setPageTitle', undefined);
  await store.dispatch('setHomeButton', false);
  if (
    to.name === 'PasswortVergessen' ||
    to.name === 'PasswortZuruecksetzen' ||
    to.name === 'Registrierung' ||
    to.name === 'Verifizierung'
  ) {
    next();
  } else {
    const authorized = await userClient
      .user()
      .then(({ data }) => {
        store.dispatch('user/setUsername', data.username);
        store.dispatch('user/setEmailVerified', data.emailVerified);
        return true;
      })
      .catch(() => false);
    if (to.name !== 'Login' && !authorized) {
      await store.dispatch('user/setUsername', undefined);
      await store.dispatch('user/setEmailVerified', false);
      next({ name: 'Login' });
    } else if (
      to.name !== 'Verifizierung' &&
      to.name !== 'Login' &&
      !store.getters['user/emailVerified']
    ) {
      next({ name: 'Verifizierung', params: { token: false } });
    } else if (to.name === 'Login' && authorized) {
      next({ name: 'Map' });
    } else {
      next();
    }
  }
});

export default router;
